import { FIND_CONNECTIONS, ALL_USERACCESS, USER_SCHOOL_NAME, All_CONNECTIONS, SENT_CONNECTIONS, RECEIVED_CONNECTIONS, FRIENDS_CONNECTIONS } from '../actions/actionTypes';

let user = localStorage.getItem('userDetails');
const initialState = user ? { loggedIn: true,filterConnectionData:[], user,userAccessData:[], schoolName:'',allConnectionData:[] ,sentConnectionData:[] ,receivedConnectionData:[],friendsData:[],showConnections:false } : {filterConnectionData:[],userAccessData:[], schoolName:'',allConnectionData:[] ,sentConnectionData:[] ,receivedConnectionData:[],friendsData:[],showConnections:false};

export default function connection(state = initialState, action) {
    switch (action.type) {
        case FIND_CONNECTIONS:
            return {
                ...state, 
                filterConnectionData:action.filterConnectionData
                
            };
        case ALL_USERACCESS:
            return {
                ...state, 
                userAccessData:action.userAccessData
                
            };
        case USER_SCHOOL_NAME:
            return {
                ...state, 
                schoolName:action.schoolName
            };
        case All_CONNECTIONS:
            return {
                ...state, 
                allConnectionData:action.allConnectionData,
                showConnections:action.showConnections
            };
        case SENT_CONNECTIONS:
            return {
                ...state, 
                sentConnectionData:action.sentConnectionData
            };
        case RECEIVED_CONNECTIONS:
            return {
                ...state, 
                receivedConnectionData:action.receivedConnectionData
            };
        case FRIENDS_CONNECTIONS:
            return {
                ...state, 
                friendsData:action.friendsData
            };
        default:
            return state
    }
}